import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalViewsConfig } from '../totalViews';

export const mediaViewerViewsConfig: StatsConfig = {
    ...totalViewsConfig,
    id: 'video_view_count', // Match API field name
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
